exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h-320[data-v-b34658b2]{min-height:320px\n}\n.organizationName[data-v-b34658b2]{color:white;background:rgba(34,37,44,0.75);display:inline-block;font-size:3.5rem !important\n}\n.organizationPicture[data-v-b34658b2]{max-width:160px;max-height:160px;width:100px;height:100px;border-style:solid;border-width:2px;border-color:rgba(255,255,255,0.5)\n}\n", ""]);

// exports
